<template>
  <base-index
    ref="baseIndex"
    :columns="columns"
    :resourceName="resourceName"
    :pk="pk"
    :disabledFilterButton="false"
    :breadcrumbs="breadcrumbs"
  >
    <template v-slot:render.image="{ item }">
      <div><img style="max-width: 100px" :src="item.image" /></div>
    </template>
    <template v-slot:render.publish="{ item }">
      <div>{{ item.publish === 1 ? "公開" : "非公開" }}</div>
    </template>
  </base-index>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      resourceName: "products",
      pk: "product_id",
      columns: [
        {
          value: "product_id",
          text: "システム管理商品ID",
          filter: true,
          type: "number",
          width: 80
        },
        {
          value: "jan_code",
          text: "商品ID",
          filter: true
        },
        {
          value: "maker_id",
          text: "提供メーカー",
          filter: true,
          type: "select",
          optionType: "common/makers",
          isProvider: true
        },
        {
          value: "name",
          text: "商品名",
          filter: true,
          width: 80
        },
        {
          value: "image",
          text: "商品画像",
          filter: false,
          sorter: false
        },
        {
          value: "publish",
          text: "公開/非公開",
          filter: true,
          width: 80,
          type: 'select',
          optionType: "common/publish"
        },
        {
          value: "sample_paid",
          text: "有償サンプル",
          filter: true,
          width: 80,
          type: 'select',
          optionType: "common/sample_paid"
        },
        {
          value: "pv",
          text: "PV数",
          filter: true,
          type: 'number',
          width: 80
        }
      ]
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "商品一覧",
          disabled: true
        }
      ];
    }
  }
};
</script>
